import React from "react";

import { Box, useMediaQuery } from "@mui/material";

import BarsChart from "../../../../components/BarsChart/BarsChart";

const BoxDistributionAccessHour = ({ data }) => {
  const isMobile = useMediaQuery("(max-width:600px)");

  // Conversione sicura dei dati in numeri, con controllo per valori non numerici
  const parsedDataset = data.map((item) => ({
    ...item,
    avg_access: isNaN(Number(item.avg_access)) ? 0 : Number(item.avg_access),
  }));

  console.log(parsedDataset);

  return (
    <Box sx={{ alignSelf: "center" }}>
      <BarsChart
        dataset={parsedDataset}
        yDataKey="hour"
        xScaleType="linear"
        yScaleType="band"
        xDataKey="avg_access"
        layout="horizontal"
        width={isMobile ? 250 : 400}
        height={400}
        series={[
          {
            dataKey: "avg_access",
            label: "Accessi medi",
            valueFormatter: (value) => `${value}`,
            color: "rgb(77, 172, 38)",
          },
        ]}
      />
    </Box>
  );
};

export default BoxDistributionAccessHour;
